/* facets.js — instant collection filtering using Section Rendering API */

document.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector("[data-collection-page]");
  if (!page) return;

  const form = document.getElementById("facets-form");
  const sortSelect = page.querySelector("[data-sort-select]");
  const grid = page.querySelector("[data-product-grid]");
  const facetsToggle = page.querySelector("[data-facets-toggle]");
  const facetsAside = page.querySelector("[data-facets]");
  const sectionId = "main-collection";

  facetsToggle?.addEventListener("click", () => facetsAside.classList.toggle("open"));

  function buildUrl() {
    const params = new URLSearchParams();

    form.querySelectorAll("[data-facet-input]").forEach(input => {
      if (input.type === "checkbox") {
        if (input.checked) params.append(input.name, input.value);
      } else if (input.value) {
        params.append(input.name, input.value);
      }
    });

    if (sortSelect?.value) params.set("sort_by", sortSelect.value);
    params.set("section_id", sectionId);

    return `${window.location.pathname}?${params.toString()}`;
  }

  async function applyFilters(pushState = true) {
    grid.style.opacity = "0.4";
    const url = buildUrl();

    try {
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("[data-product-grid]");
      const newFacets = doc.querySelector("[data-facets]");
      const newCount = doc.querySelector("[data-result-count]");
      const newPagination = doc.querySelector("[data-pagination]");

      if (newGrid) grid.innerHTML = newGrid.innerHTML;
      if (newFacets) facetsAside.innerHTML = newFacets.innerHTML;
      if (newCount) page.querySelector("[data-result-count]").textContent = newCount.textContent;

      const oldPagination = page.querySelector("[data-pagination]");
      if (oldPagination) oldPagination.innerHTML = newPagination ? newPagination.innerHTML : "";

      if (pushState) {
        const cleanUrl = url.replace(/([&?])section_id=[^&]+&?/, "$1").replace(/[?&]$/, "");
        window.history.pushState({}, "", cleanUrl);
      }

      document.dispatchEvent(new CustomEvent("facets:updated"));
    } catch (err) {
      console.error("Filter request failed", err);
    } finally {
      grid.style.opacity = "1";
    }
  }

  form.addEventListener("change", (e) => {
    if (e.target.matches("[data-facet-input]")) applyFilters();
  });
  sortSelect?.addEventListener("change", () => applyFilters());

  page.addEventListener("click", (e) => {
    if (e.target.matches("[data-clear-filters]")) {
      e.preventDefault();
      form.querySelectorAll("[data-facet-input]").forEach(i => {
        if (i.type === "checkbox") i.checked = false; else i.value = "";
      });
      applyFilters();
    }
    // Support pagination links rendered inside the section swap
    const paginationLink = e.target.closest("[data-pagination] a");
    if (paginationLink) {
      e.preventDefault();
      window.scrollTo({ top: page.offsetTop - 40, behavior: "smooth" });
      fetch(`${paginationLink.href}${paginationLink.href.includes("?") ? "&" : "?"}section_id=${sectionId}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          grid.innerHTML = doc.querySelector("[data-product-grid]").innerHTML;
          const newPag = doc.querySelector("[data-pagination]");
          page.querySelector("[data-pagination]").innerHTML = newPag ? newPag.innerHTML : "";
          window.history.pushState({}, "", paginationLink.href);
        });
    }
  });
});
